import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang

Vue.use(VueI18n)

const messages = {
    zh: {
        ...zh,
        ...elementZhLocale
    },
    en: {
        ...en,
        ...elementEnLocale
    }
}
const urlQuery = getQueryLang()
if (urlQuery.lang) {
    localStorage.setItem('lang', urlQuery.lang)
}
// 设置小logo
if (urlQuery.netLogoUrl) {
    localStorage.setItem('netLogoUrl', urlQuery.netLogoUrl)
}
console.log('获取到URL参数', urlQuery)
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'zh',
    messages
})

function getQueryLang () {
    const href = location.href
    const queryStr = href.split('?')[1]
    const result = {}
    if (queryStr) {
        const queryArr = queryStr.split('&')
        queryArr.forEach(item => {
            const _arr = item.split('=')
            result[_arr[0]] = _arr[1] || ''
        })
    }
    return result
}
  
export default i18n